import { Component, inject, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { TableAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ConceptFamilyTableModel } from 'src/app/models/tables/management/concept-family-table.model';
import { ConceptFamilyService } from 'src/app/services/management/concept-family.service';

@Component({
  selector: 'app-concept-family-for-accounting-model',
  templateUrl: './concept-family-for-accounting-model.component.html',
  styleUrls: ['./concept-family-for-accounting-model.component.scss'],
  standalone: false
})
export class ConceptFamilyForAccountingModelComponent implements OnInit {

  private readonly conceptFamilyService = inject(ConceptFamilyService);

  ascendant: boolean = true;
  columnSort: string | null = null;
  data: PagedResponseModel<ConceptFamilyTableModel> = new PagedResponseModel<ConceptFamilyTableModel>();
  filters: ColumnResponseModel[] = [];
  header: ColumnResponseModel[] = [];
  limit: number = 10;
  page: number = 1;
  tableActions: TableAction[] = [];
  url: string = 'accounting-model-concept-family';

  async ngOnInit() {
    const filters = localStorage.getItem(`${this.url}`);
    if (filters) this.filters = JSON.parse(filters);
    await Promise.all([
      this.getColumnsForGeneralConsultationForAccountingModel(),
      this.getAllConceptFamiliesForAccountingModelWithPagination(),
    ]);
  }

  async getAllConceptFamiliesForAccountingModelWithPagination() {
    try {
      this.data = await firstValueFrom(
        this.conceptFamilyService.getAllConceptFamiliesForAccountingModelWithPaginationAsync(
          this.page, this.limit, this.columnSort, this.ascendant, this.filters
        )
      );
    } catch (error) {
      console.error('Error al buscar los conceptos-familia para modelo contable.', error);
    }
  }

  async getColumnsForGeneralConsultationForAccountingModel() {
    try {
      if (this.header.length === 0) {
        this.header = await firstValueFrom(
          this.conceptFamilyService.getColumnsForGeneralConsultationForAccountingModelAsync()
        );
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta general de los conceptos-familia para modelo contable.', error);
    }
  }

  async onExport() {
    try {
      const response = await firstValueFrom(this.conceptFamilyService.exportGeneralConsultation(this.filters, this.columnSort, this.ascendant));
      const blob = response;
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'Consulta Concepto Familia.xlsx';
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error al exportar la consulta de concepto-familia.', error);
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async onPageChange(event: { page: number; pageSize: number; sortField?: string; sortOrder: number }) {
    this.page = event.page;
    this.limit = event.pageSize;
    this.columnSort = event.sortField ?? null;
    this.ascendant = event.sortOrder === 1;
    await this.getAllConceptFamiliesForAccountingModelWithPagination();
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

}
